export const ABOUT_CONTENT = {
  title: 'ABOUT',
  text: 'Learn more about our salon, and our commitment to providing exceptional hair care services.',
};

export const SERVICES_CONTENT = {
  title: 'SERVICES',
  text: 'Explore our range of hair care services, from cutting and styling to coloring and treatments. Let our expert stylists bring out the best in your hair.',
};

export const GALLERY_CONTENT = {
  title: 'GALLERY',
  text: 'Browse our gallery to see stunning transformations and hairstyles created by our skilled stylists. Get inspired for your next look.',
};

export const CONTACT_CONTENT = {
  title: 'CONTACT',
  text: "Find our salon's location, contact details, and hours of operation. Reach out to us for any inquiries or to schedule your next visit.",
};

export const BOOKING_CONTENT = {
  title: 'BOOKING',
  text: 'Schedule your appointment with ease. Select your preferred service, stylist, and time to ensure a seamless and personalized salon experience.',
};
